import React, { useEffect } from "react";
import { connect } from "react-redux";
import PageHeader from "../../../shared/components/PageHeader";
import { Container, Row } from "reactstrap";
import InstitutionTable from "./components/InstitutionTable";
import { getInstitutions, resetViewInstitution } from "../actions/institution.actions";

const InstitutionView = ({ dispatch, allInstitutions }) => {

  const loadInstitution = (requestParams) => {
    dispatch(getInstitutions(requestParams));
  };

  useEffect(() => {
    dispatch(getInstitutions({ pageNum: 1, pageSize: 10, searchKey: "" }));
    dispatch(resetViewInstitution())
  }, [dispatch]);

  return (
    <Container>
      <PageHeader
        header="Registered institutions"
        subheader="All institutions added to the portal are listed here"
      />
      <Row>
        <InstitutionTable
          dataState={allInstitutions}
          fetchData={loadInstitution}
        />
      </Row>
    </Container>
  );
};

export default connect((state) => ({
  allInstitutions: state.getInstitution
}))(InstitutionView);

